export const FETCH_QUOTATIONS = 'quotation/FETCH_QUOTATIONS'
export const FETCH_QUOTATIONS_SUCCESS = 'quotation/FETCH_QUOTATIONS_SUCCESS'
export const FETCH_QUOTATIONS_FAILURE = 'quotation/FETCH_QUOTATIONS_FAILURE'
export const RESET_QUOTATIONS = 'quotation/RESET_QUOTATIONS'

export const FETCH_QUOTATION = 'quotation/FETCH_QUOTATION'
export const FETCH_QUOTATION_SUCCESS = 'quotation/FETCH_QUOTATION_SUCCESS'
export const FETCH_QUOTATION_FAILURE = 'quotation/FETCH_QUOTATION_FAILURE'
export const RESET_QUOTATION = 'quotation/RESET_QUOTATION'

export const CREATE_QUOTATION = 'quotation/CREATE_QUOTATION'
export const CREATE_QUOTATION_SUCCESS = 'quotation/CREATE_QUOTATION_SUCCESS'
export const CREATE_QUOTATION_FAILURE = 'quotation/CREATE_QUOTATION_FAILURE'
export const RESET_CREATE_QUOTATION = 'quotation/RESET_QUOTATION'

export const UPDATE_QUOTATION = 'quotation/UPDATE_QUOTATION'
export const UPDATE_QUOTATION_SUCCESS = 'quotation/UPDATE_QUOTATION_SUCCESS'
export const UPDATE_QUOTATION_FAILURE = 'quotation/UPDATE_QUOTATION_FAILURE'
export const RESET_UPDATE_QUOTATION = 'quotation/RESET_UPDATE_QUOTATION'

export const DELETE_QUOTATION = 'offer/DELETE_QUOTATION'
export const DELETE_QUOTATION_SUCCESS = 'offer/DELETE_QUOTATION_SUCCESS'
export const DELETE_QUOTATION_FAILURE = 'offer/DELETE_QUOTATION_FAILURE'
export const RESET_DELETE_QUOTATION = 'offer/RESET_DELETE_QUOTATION'



// WEBPACK FOOTER //
// ./src/store/quotation/actionTypes.js